// @flow
import config from '../../../config';

const getPaymentMeanPage = () => {
  switch (config.paymentProvider) {
    case 'stripe':
      return require('./paymentProvider/stripe/StripePayment.container').default;
    default:
      throw new Error('Unsupported payment provider');
  }
};

export default getPaymentMeanPage();
